'use client';

import {styled} from "@mui/system";
import {Box} from "@mui/material";

const LastUpdateBox = styled(Box)(({theme}) => ({
    fontSize: '.8rem',
    alignItems: 'center',
    textAlign: 'right',
    display: 'flex',
    justifyContent: 'flex-end',
    color: theme.palette.text.secondary,
    ' .icon': {
      color: theme.palette.success.main,
        marginRight: theme.spacing(.25) ,
    },
    ' span': {
        color: 'inherit',
        fontSize: 'inherit',
    },
}));

export default LastUpdateBox;
